<ion-list>
  @for(item of endpointGroups(); track item) {
    <ion-item [color]="item.GROUP_ID === activeEndpoint()?.id ? 'primary' : ''"  (click)="selectItem(item)">
      {{item.GROUP_NAME}}: {{item.DESCRIPTION}}
    </ion-item>
  }
</ion-list>
